var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"interaction-helper"}}),_c('transition',{attrs:{"mode":"out-in"},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"before-leave":_vm.beforeLeave,"leave":_vm.leave}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }